export default "__VITE_ASSET__CZYKdIvm__"